import actions from "./actions";

const {
    FETCH_SALARY_DECLARATIONS,
    FETCH_SALARY_DECLARATION,
    RESET_SALARY_DECLARATION,
    FETCH_USER_MONTHLY_ATTENDANCE,
    RESET_USER_MONTHLY_ATTENDANCE,
    SINGLE_USER
} = actions;

const initState = {
    salaryDeclarations: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    salaryDeclaration: {
        salaryDeclaration: { _id: null },
        employeeIncrement: {
            currentIncrement: { _id: null },
            previousIncrement: [],
        }

    },
    // salaryDeclaration: { _id: null },
    userMonthlyAttendance: [],
    userId: null,
};

const SalaryDeclarationReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_SALARY_DECLARATIONS:
            return {
                ...state,
                salaryDeclarations: data
            };
        case RESET_SALARY_DECLARATION:
            return {
                ...state,
                salaryDeclaration: initState.salaryDeclaration,
                userMonthlyAttendance: initState.userMonthlyAttendance
            };
        case FETCH_SALARY_DECLARATION:
            return {
                ...state,
                salaryDeclaration: data
            };
        case FETCH_USER_MONTHLY_ATTENDANCE:
            return {
                ...state,
                userMonthlyAttendance: data
            };
        case RESET_USER_MONTHLY_ATTENDANCE:
            return {
                ...state,
                userMonthlyAttendance: []
            };
        case SINGLE_USER:
            return {
                ...state,
                userId: data
            };
        default:
            return state;
    }
};

export default SalaryDeclarationReducer;
